module.exports = __webpack_public_path__ + "img/template-qr.ed3c76e2.png";